import React from "react";
import GroupedWidget from "./grouped-widget";
import WidgetInfo from "./widget-info";

const WidgetsRenderDefaultAlignment = ({ widgets, from, to }) => {
    return (
        <GroupedWidget name="Default" widgets={widgets} from={from} to={to} />
    );
};

const WidgetsRenderMultiColumnsAlignment = ({ widgets, from, to, theme }) => {
    let results = [];
    let lastAlignment = "";
    let pointer = from;

    for (let index = from; index <= to; index++) {
        const widget = widgets[index];
        const { renderAlignment: widgetAlignment } = WidgetInfo.get(widget);
        const isFirst = index == from;
        const isLast = index == to;

        if (isFirst) lastAlignment = widgetAlignment;

        if (lastAlignment !== widgetAlignment) {
            results.push(
                <GroupedWidget
                    key={results.length + 1}
                    name={lastAlignment}
                    widgets={widgets}
                    from={pointer}
                    to={index - 1}
                    align={lastAlignment}
                />
            );
            lastAlignment = widgetAlignment;
            pointer = index;
        }

        if (isLast) {
            results.push(
                <GroupedWidget
                    key={results.length + 1}
                    name={lastAlignment}
                    widgets={widgets}
                    from={pointer}
                    to={index}
                    align={lastAlignment}
                />
            );
        }
    }

    const cssClass =
        theme == "Alternative" || theme == "Default"
            ? "flex flex-col md:flex-row gap-9"
            : "flex flex-col gap-9";

    return <div className={cssClass}>{results}</div>;
};

const WidgetsRenderByAlignment = ({ widgets, from, to }) => {
    let isDefault = false;
    let pointer = from;
    let results = [];
    let lastTheme = "";

    for (let index = from; index <= to; index++) {
        const widget = widgets[index];
        const { renderAlignment: widgetAlignment, renderTheme: widgetTheme } =
            WidgetInfo.get(widget);
        const widgetIsDefault = widgetAlignment === "Default";

        const isFirst = index === from;
        const isLast = index === to;

        if (isFirst) {
            isDefault = widgetIsDefault;
            lastTheme = widgetTheme;
        }

        if (isDefault != widgetIsDefault) {
            const cmp = isDefault ? (
                <WidgetsRenderDefaultAlignment
                    key={results.length + 1}
                    widgets={widgets}
                    from={pointer}
                    to={index - 1}
                />
            ) : (
                <WidgetsRenderMultiColumnsAlignment
                    key={results.length + 1}
                    widgets={widgets}
                    from={pointer}
                    to={index - 1}
                    theme={lastTheme}
                />
            );
            results.push(cmp);

            isDefault = widgetIsDefault;
            lastTheme = widgetTheme;
            pointer = index;
        }

        if (isLast) {
            const cmp = widgetIsDefault ? (
                <WidgetsRenderDefaultAlignment
                    key={results.length + 1}
                    widgets={widgets}
                    from={pointer}
                    to={index}
                />
            ) : (
                <WidgetsRenderMultiColumnsAlignment
                    key={results.length + 1}
                    widgets={widgets}
                    from={pointer}
                    to={index}
                    theme={lastTheme}
                />
            );
            results.push(cmp);
        }
    }
    return results;
};

export default WidgetsRenderByAlignment;
